import React, { useEffect } from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";
import { getI18n } from "../../utils/intl";
import { useIntl } from "react-intl";
import styles from "./styles";
import PropTypes from "prop-types";

const PasswordPolicy = (props) => {

  const {
    regexPolicy,
    fetchPasswordPolicy,
  } = props


  const intl = getI18n(useIntl());
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  
  useEffect(() => {
    fetchPasswordPolicy();
  }, [])
  
  const passwordRequirementsList = React.useMemo(() => {
    if (!regexPolicy) return [];

    const list = [];
    Object.keys(regexPolicy).forEach(key => {
      const valObj = regexPolicy[key];

      if (key !== "REGEX" && key !== 'SUPPORTED_SYMBOLS' && key !== 'PASSWORD_EXPIRY' && valObj && valObj.enabled) {
        if (key === "SYMBOL") {
          list.push(intl.getI18nMessage(`label.user.profile.password.requirements.${key}`,
            {
              val: valObj.value,
              chars: regexPolicy["SUPPORTED_SYMBOLS"].value,
            }));
        } else {
          list.push(intl.getI18nMessage(`label.user.profile.password.requirements.${key}`,
            {
              val: valObj.value,
            }));
        }
      }
    });

    return list;
  }, [regexPolicy]);

  return <>
    <Typography variant='body1' className={classes.passwordPolicyLabel}>{intl.getI18nMessage("label.user.profile.password.requirements.text")}</Typography>
    <Box ml={1} mt={1} className={classes.passwordPolicy}>
      {passwordRequirementsList.map((item) => (
        <li key={item}>
          <Typography variant='body1' component='span'>{item}</Typography>
        </li>
      ))}
    </Box>
  </>
}

PasswordPolicy.propTypes = {
  regexPolicy: PropTypes.object,
  fetchPasswordPolicy: PropTypes.func,
}

export default PasswordPolicy;